import {
  EventAccordionItemBodyComponentType,
  MinRowsForUsingVirtuoso,
} from 'src/components/Accordions';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { SalesTable } from 'src/tables/SalesTable';
import { SalesTableV2 } from 'src/tables/SalesTable/SalesTableV2';
import { SaleTiles } from 'src/tiles/SaleTiles';
import { Feature, Sale } from 'src/WebApiController';

type EventSaleBodyProps = EventAccordionItemBodyComponentType<Sale>;

export const EventSaleBody = (props: EventSaleBodyProps) => {
  const hasSalesTableV2Feature = useUserHasFeature(Feature.SalesTableV2);
  const isMobile = useMatchMedia('mobile');
  const Body = isMobile
    ? SaleTiles
    : hasSalesTableV2Feature && !props.isSideTable
      ? SalesTableV2
      : SalesTable;
  const usingVirtuoso = props.entityCount > MinRowsForUsingVirtuoso;

  return (
    <Body
      {...props}
      useVirtuoso={props.useVirtuoso || usingVirtuoso}
      enableColumnFilters
    />
  );
};
